import { render } from "./Controls.vue?vue&type=template&id=4cb6801e"
import script from "./Controls.vue?vue&type=script&lang=js"
export * from "./Controls.vue?vue&type=script&lang=js"

import "./Controls.vue?vue&type=style&index=0&id=4cb6801e&lang=css"

import exportComponent from "/tmp/workspace1/source/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__